(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbcino-approved-mockup"] && !Shopify.designMode) return;
  try {
    
function initBbcinoHomepage(){
 document.querySelectorAll('.bbdraft-originals').forEach(root=>{
  if(root.dataset.ready==='true')return;
  root.dataset.ready='true';
  root.querySelectorAll('.bbdraft-video-toggle').forEach(button=>{
   const video=button.parentElement.querySelector('video');
   if(!video)return;
   function update(){const playing=!video.paused;button.classList.toggle('is-playing',playing);button.setAttribute('aria-label',playing?root.dataset.pauseLabel:root.dataset.playLabel);button.querySelector('span').textContent=playing?'Ⅱ':'▶';}
   button.addEventListener('click',()=>{if(video.paused){video.play().catch(()=>{});}else{video.pause();}});
   video.addEventListener('play',update);video.addEventListener('pause',update);update();
  });

  const track=root.querySelector('.bbdraft-seller-track');
  if(track){let paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;let visible=false;let interacting=false;const pause=root.querySelector('[data-seller-pause]');function advance(step){const atEnd=track.scrollLeft>=track.scrollWidth-track.clientWidth-5;const atStart=track.scrollLeft<5;const destination=step>0&&atEnd?0:step<0&&atStart?track.scrollWidth-track.clientWidth:track.scrollLeft+step*track.clientWidth;track.scrollTo({left:destination,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}root.querySelectorAll('[data-seller-step]').forEach(button=>button.addEventListener('click',()=>advance(Number(button.dataset.sellerStep))));function updatePause(){if(!pause)return;pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?root.dataset.resumeSlideshow:root.dataset.pauseSlideshow);}if(pause)pause.addEventListener('click',()=>{paused=!paused;updatePause();});updatePause();track.addEventListener('mouseenter',()=>interacting=true);track.addEventListener('mouseleave',()=>interacting=false);track.addEventListener('focusin',()=>interacting=true);track.addEventListener('focusout',()=>interacting=false);const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;},{threshold:.6});observer.observe(track);const timer=setInterval(()=>{if(!paused&&visible&&!interacting&&!document.hidden)advance(1);if(!root.isConnected){clearInterval(timer);observer.disconnect();}},5000);}

  const reviews=root.querySelector('.bbdraft-reviews-slides');
  const slides=Array.from(root.querySelectorAll('.bbdraft-review-slide'));let index=0;
  if(reviews&&slides.length){
   const counter=root.querySelector('.bbdraft-review-counter');
   const resize=()=>{reviews.style.height=slides[index].getBoundingClientRect().height+'px';};
   const go=step=>{index=(index+step+slides.length)%slides.length;resize();reviews.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
   root.querySelectorAll('[data-review-step]').forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.reviewStep))));
   let settle;reviews.addEventListener('scroll',()=>{clearTimeout(settle);settle=setTimeout(()=>{index=Math.max(0,Math.min(slides.length-1,Math.round(reviews.scrollLeft/reviews.clientWidth)));counter.textContent=(index+1)+' / '+slides.length;resize();},100);});
   reviews.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(event.key==='ArrowRight'?1:-1);}});
   const observer=new ResizeObserver(resize);slides.forEach(slide=>observer.observe(slide));resize();
  }
 });
}
initBbcinoHomepage();
document.addEventListener('shopify:section:load',initBbcinoHomepage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on the FAQ page
    if (window.location.pathname === '/pages/faq') {
        // Select the footer element
        var footer = document.querySelector('.m-footer');
        
        // Ensure the element exists before trying to change it
        if (footer) {
            // Function to change the background image based on screen size
            function updateFooterImage() {
                if (window.matchMedia("(max-width: 767px)").matches) {
                    // For screens 767px or less
                    footer.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0635/6772/4787/files/faqwavy.png?v=1728723255')";
                } else {
                    // For screens larger than 767px
                    footer.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0635/6772/4787/files/elzaMask-group.png?v=1727946145')";
                }
            }
            
            // Run the function on page load
            updateFooterImage();
            
            // Update the image if the screen is resized
            window.addEventListener('resize', updateFooterImage);
        }
    }
});



  
  } catch(e) { console.error(e); }
})();
})();
